import { Specialty } from "./specialty.model";

export const specialties: Specialty[] = [
  {
    SpecialtyID: 1,
    SpecialtyName: 'United States',
    SpecialtyAlias: 'The United States of America',
  },
  {
    SpecialtyID: 2,
    SpecialtyName: 'United Kingdom',
    SpecialtyAlias: 'The United Kingdom of Great Britain and Northern Ireland',
  },
  {
    SpecialtyID: 3,
    SpecialtyName: 'France',
    SpecialtyAlias: 'The French Republic',
  },
  {
    SpecialtyID: 4,
    SpecialtyName: 'Germany',
    SpecialtyAlias: 'The Federal Republic of Germany',
  },
  {
    SpecialtyID: 5,
    SpecialtyName: 'Canada',
    SpecialtyAlias: 'Canada',
  },
];
